.ux-iws-onboarding-guide {
    position: relative;

    div[slot="spinner"] {
        opacity: 1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }

    .ux-slider-slide {
        width: 100% !important;
    }
}

.ux-iws-onboarding-guide__content {
    padding: 0 1px;

    @media only screen and (min-width: $desktop-s) {
        display: flex;
        justify-content: space-between;
    }

    .ux-iws-onboarding-guide__text-wrapper {
        width: 100%;
        margin-bottom: 30px;

        @media only screen and (min-width: $desktop-s) {
            width: 45%;
            margin-bottom: 0;
        }
    }

    .ux-iws-onboarding-guide__copy {
        line-height: 1.2;
    }

    .ux-iws-onboarding-guide__hint {
        display: flex;
        align-items: center;
        color: $color-gray-text;
        line-height: 1.2;

        ux-icon {
            margin-right: 10px;
        }
    }

    .ux-iws-onboarding-guide__machines-wrapper {
        width: 100%;

        .ux-slider__content-container {
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
    }

    .ux-iws-onboarding-guide__button-wrapper {
        display: flex;
        flex-direction: column;

        @media only screen and (min-width: $tablet) {
            flex-direction: row;
        }

        /* stylelint-disable max-nesting-depth */
        ux-button {
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            @media only screen and (min-width: $tablet) {
                margin-bottom: 0;
                margin-right: 20px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
        /* stylelint-enable max-nesting-depth */
    }

    .ux-iws-onboarding-guide__machines {
        display: flex;
        align-items: center;
        margin-bottom: 0;
    }

    .ux-iws-onboarding-guide__machines-media {
        width: 100px;
        @include aspect-ratio(1, 1);
        margin-right: 30px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            left: 0;
            top: 0;
            position: absolute;
        }
    }

    .ux-iws-onboarding-guide__media-wrapper {
        width: 100%;

        @media only screen and (min-width: $desktop-s) {
            width: 50%;
        }
    }

    .ux-iws-onboarding-guide__media_caption {
        @media only screen and (min-width: $desktop-s) {
            text-align: center;
        }
    }
}

.ux-iws-onboarding-guide__table-of-contents-wrapper {
    width: 100%;

    @media only screen and (min-width: $desktop-s) {
        display: flex;
        justify-content: space-between;
    }

    .ux-iws-onboarding-guide__table-of-contents-left,
    .ux-iws-onboarding-guide__table-of-contents-right {
        width: 100%;

        @media only screen and (min-width: $desktop-s) {
            width: 48%;
        }
    }
}

.ux-iws-onboarding-guide__table-of-contents-link {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background-color 2s ease-in-out;
    position: relative;

    &::before {
        content: "";
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            to right,
            $color-blue-highlight-6,
            $color-white 100%
        );
        position: absolute;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
    }

    .ux-iws-onboarding-guide__table-of-contents-text {
        z-index: 1;
    }

    .ux-iws-onboarding-guide__table-of-contents-link-number {
        color: $color-green;
        margin-right: 20px;
    }

    ux-icon {
        z-index: 1;
        transition: transform 0.2s ease-in-out;
    }

    &:hover {
        &::before {
            opacity: 1;
        }

        ux-icon {
            transform: translate(5px, 0);
        }
    }
}

.ux-iws-onboarding-guide__custom-navigation {
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: $tablet) {
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
    }

    .ux-iws-onboarding-guide__button-wrapper {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }

        @media only screen and (min-width: $tablet) {
            margin-bottom: 0;
        }

        @media only screen and (min-width: $desktop-m) {
            flex-direction: row;
        }

        /* stylelint-disable max-nesting-depth */
        ux-button {
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            @media only screen and (min-width: $desktop-m) {
                margin-bottom: 0;
                margin-right: 20px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
        /* stylelint-enable max-nesting-depth */
    }
}
